import {createApi} from '@reduxjs/toolkit/query/react';

import {browserStorageKey} from '../constants/browserStorageKey';
import {academyBaseQuery} from './academyBaseQuery';

export interface Video {
  name: string;
  presenter: string;
  length: string;
  id: string;
  meetup: string;
  department: string;
}

export interface Meetup {
  name: string;
  department: string;
}

type Recordings = {
  videos: Video[];
  meetups: Meetup[];
};

type SheetResponse = {
  sheets?: {
    data?: {
      rowData?: {
        values?: {
          formattedValue?: string | null;
        }[];
      }[];
    }[];
  }[];
};

export const academyApi = createApi({
  baseQuery: academyBaseQuery,
  reducerPath: 'rtk_academyApi',
  tagTypes: [''],
  endpoints: (build) => ({
    getVideos: build.query<Recordings, void>({
      query: () => ({
        url: 'academy',
        params: {
          access_token: sessionStorage.getItem(browserStorageKey.ACCESS_TOKEN),
        },
      }),
      transformResponse(result: SheetResponse) {
        const videosRowData = result?.sheets?.[0]?.data?.[0]?.rowData?.slice?.(1);
        const meetupsRowData = result?.sheets?.[1]?.data?.[0]?.rowData?.slice?.(1);

        return {
          meetups:
            meetupsRowData?.map((row) => ({
              name: row?.values?.[0]?.formattedValue ?? '',
              department: row?.values?.[1]?.formattedValue ?? '',
            })) ?? [],
          videos:
            videosRowData
              ?.filter((row) => !!row?.values?.[0]?.formattedValue)
              .map((row) => ({
                name: row?.values?.[0]?.formattedValue ?? '',
                presenter: row?.values?.[1]?.formattedValue ?? '',
                length: row?.values?.[2]?.formattedValue ?? '',
                id: row?.values?.[3]?.formattedValue ?? '',
                meetup: row?.values?.[4]?.formattedValue ?? '',
                department: row?.values?.[5]?.formattedValue ?? '',
              })) ?? [],
        };
      },
    }),
  }),
});

export const {useGetVideosQuery} = academyApi;
